module.exports = __webpack_public_path__ + "img/resized-APP-0020-2.d1602804.png";